import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid } from '@mui/material';
import { AlertWidget } from '../../../widgets';
import './styles.css';
import TableroAdminView from '../admin';
import TableroTeacherView from '../teacher';
import TableroStudentView from '../student';

const TableroView = () => {
  const loginStore = Redux.useSelector((state) => state.login);
  const tableroStore = Redux.useSelector((state) => state.tablero);

  return (
    <Grid container spacing={1}>
      <AlertWidget alert={tableroStore.alertView} />
      <Grid item md={12}>
        {loginStore.isAdmin ? (
          <TableroAdminView />
        ) : loginStore.isTeacher ? (
          <TableroTeacherView />
        ) : (
          <TableroStudentView />
        )}
      </Grid>
    </Grid>
  );
};

export default TableroView;
